import { render, staticRenderFns } from "./module-tran.vue?vue&type=template&id=4e39f32c&scoped=true"
import script from "./module-tran.vue?vue&type=script&lang=js"
export * from "./module-tran.vue?vue&type=script&lang=js"
import style0 from "./module-tran.vue?vue&type=style&index=0&id=4e39f32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39f32c",
  null
  
)

export default component.exports